var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9534 17.1163H10.0465C9.43622 17.1163 8.93018 16.6102 8.93018 16C8.93018 15.3898 9.43622 14.8838 10.0465 14.8838H21.9534C22.5637 14.8838 23.0697 15.3898 23.0697 16C23.0697 16.6102 22.5637 17.1163 21.9534 17.1163Z",
    fill: "#0b8369"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 23.0697C15.3897 23.0697 14.8837 22.5637 14.8837 21.9535V10.0465C14.8837 9.43622 15.3897 8.93018 15.9999 8.93018C16.6102 8.93018 17.1162 9.43622 17.1162 10.0465V21.9535C17.1162 22.5637 16.6102 23.0697 15.9999 23.0697Z",
    fill: "#0b8369"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4651 32H11.5349C3.45302 32 0 28.547 0 20.4651V11.5349C0 3.45302 3.45302 0 11.5349 0H20.4651C28.547 0 32 3.45302 32 11.5349V20.4651C32 28.547 28.547 32 20.4651 32ZM11.5349 2.23256C4.67349 2.23256 2.23256 4.67349 2.23256 11.5349V20.4651C2.23256 27.3265 4.67349 29.7674 11.5349 29.7674H20.4651C27.3265 29.7674 29.7674 27.3265 29.7674 20.4651V11.5349C29.7674 4.67349 27.3265 2.23256 20.4651 2.23256H11.5349Z",
    fill: "#0b8369"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.a70d3aafc2790fc257e126db0cb9e24f.svg";
export { ForwardRef as ReactComponent };